import { Button, Container, Paper, Stack, Typography, Select, MenuItem, Box } from '@mui/material';
import { FormProvider } from '../../../../../components';
import { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import { dropdownFetch, toast } from '../../../../../utils';
import { BASE_URL } from '../../../../../utils';
export const UserManagement = () => {
  const [currentAction, setCurrentAction] = useState('');
  const [selectedRecord, setSelectedRecord] = useState({});
  const [roleDropdown, setRoleDropdown] = useState([]);
  const [userList, setUserList] = useState([]);
  const [selectedUser, setSelectedUser] = useState('');

  const getRoleDropdown = useCallback(async () => {
    const data = await dropdownFetch('role');
    setRoleDropdown(data);
  }, []);

  const getUserList = useCallback(async () => {
    try {
      const response = await axios.get(`${BASE_URL}/user`);
      setUserList(response.data);
    } catch (error) {
      console.error('Error fetching user list:', error);
    }
  }, []);

  useEffect(() => {
    getRoleDropdown();
  }, [getRoleDropdown]);

  const formSubmitHandler = async (event) => {
    event.preventDefault();
    try {
      if (currentAction === 'new') {
        await axios.post(`${BASE_URL}/register`, selectedRecord);
        toast(`User created successfully`, { variant: 'success' });
      } else if (currentAction === 'edit') {
        await axios.put(`${BASE_URL}/user/${selectedUser}`, selectedRecord);
        toast(`User updated successfully`, { variant: 'success' });
      }
      setCurrentAction('');
      setSelectedUser('');
      setSelectedRecord({});
      getUserList();
    } catch (error) {
      console.error('Error submitting form:', error);
      toast(`Something Went Wrong`, { variant: 'warning' });
    }
  };

  const handleDeleteRecord = async () => {
    try {
      await axios.delete(`${BASE_URL}/user/${selectedUser}`);
      toast(`User deleted successfully`, { variant: 'success' });
      setCurrentAction('');
      setSelectedUser('');
      setSelectedRecord({});
      getUserList();
    } catch (error) {
      console.error('Error deleting user:', error);
      toast(`Something Went Wrong`, { variant: 'warning' });
    }
  };

  const handleQuery = () => {
    getUserList();
    setCurrentAction('query');
  };

  const handleSelectUser = async (event) => {
    const userId = event.target.value;
    try {
      const response = await axios.get(`${BASE_URL}/user/${userId}`);
      const user = response.data;
      setSelectedUser(user._id);
      const { _id, ...userWithoutId } = user;
      setSelectedRecord(userWithoutId);
      setCurrentAction('edit');
    } catch (error) {
      console.error('Error fetching user data:', error);
    }
  };

  const handleCancel = () => {
    setCurrentAction('');
    setSelectedUser('');
    setSelectedRecord({});
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    setSelectedRecord((prevRecord) => ({
      ...prevRecord,
      [name]: value
    }));
  };

  const inputStyle = {
    width: '60%',
    paddingTop: '3px',
    paddingBottom: '3px'
  };

  return (
    <>
      <Paper sx={{ p: 0, flex: 1, borderRadius: 0, boxShadow: 'none' }}>
        <Container
          sx={{
            mt: 1,
            border: '0px solid',
            borderColor: 'grey.300',
            borderRadius: 1,
            width: '100%',
            maxWidth: 'none',
            minWidth: '100%',
            boxSizing: 'border-box'
          }}
        >
          <FormProvider onSubmit={formSubmitHandler}>
            <Stack
              direction="row"
              spacing={2}
              justifyContent="space-between"
              alignItems="center"
              sx={{
                mb: 1,
                borderBottom: '0px solid',
                borderColor: 'grey.300'
              }}
            >
              <Typography color="primary" variant="h3" sx={{ fontWeight: 600 }}>
                User Management
              </Typography>
              <Stack direction="row" justifyContent="flex-end" sx={{ mb: 3 }} spacing={1}>
                <Button
                  variant="contained"
                  disabled={['new', 'edit'].includes(currentAction)}
                  onClick={() => {
                    setSelectedRecord({});
                    setCurrentAction('new');
                  }}
                >
                  New
                </Button>
                <Button type="submit" variant="contained" disabled={!['new', 'edit'].includes(currentAction)}>
                  Save
                </Button>
                <Button variant="contained" disabled={!['new', 'edit'].includes(currentAction)} onClick={handleCancel}>
                  Cancel
                </Button>
                <Button
                  variant="contained"
                  disabled={!selectedUser || !['query', 'edit'].includes(currentAction)}
                  onClick={handleDeleteRecord}
                >
                  Delete
                </Button>
                <Button
                  variant="contained"
                  disabled={['new', 'edit', 'query'].includes(currentAction)}
                  onClick={handleQuery}
                >
                  Query
                </Button>
                <Button
                  variant="contained"
                  onClick={() => {
                    setCurrentAction('');
                    setSelectedUser('');
                    setSelectedRecord({});
                  }}
                >
                  Exit
                </Button>
              </Stack>
            </Stack>
            {currentAction === 'query' && (
              <Stack spacing={2} direction="row" sx={{ mb: 2 }}>
                <Select
                  value={selectedUser}
                  onChange={handleSelectUser}
                  displayEmpty
                  inputProps={{ 'aria-label': 'Without label' }}
                  fullWidth
                >
                  <MenuItem value="">
                    <em>Select User</em>
                  </MenuItem>
                  {userList.map((user) => (
                    <MenuItem key={user._id} value={user._id}>
                      {user.first_name} {user.last_name}
                    </MenuItem>
                  ))}
                </Select>
              </Stack>
            )}
            <Box
              sx={{
                border: '0px solid gray',
                padding: 2,
                borderRadius: '8px',
                width: '80%',
                boxShadow: '0px 2px 10px #0099ff'
              }}
            >
              <Stack spacing={2} direction="row" sx={{ mb: 0.25 }}>
                <Stack sx={{ flex: 0.4 }} direction="row" spacing={0.5} alignItems="center">
                  <Typography sx={{ flex: 0.8, fontWeight: 700, fontSize: '14px' }}>First Name</Typography>
                  <input
                    style={inputStyle}
                    name="first_name"
                    sx={{ flex: 0.8 }}
                    placeholder="Enter First Name"
                    value={selectedRecord.first_name || ''}
                    onChange={handleChange}
                    disabled={!['new', 'edit'].includes(currentAction)}
                  />
                </Stack>
                <Stack sx={{ flex: 0.4 }} spacing={0.5} direction="row" alignItems="center">
                  <Typography sx={{ flex: 0.8, fontWeight: 700, fontSize: '14px' }}>Last Name</Typography>
                  <input
                    style={inputStyle}
                    name="last_name"
                    sx={{ flex: 0.8 }}
                    placeholder="Enter Last Name"
                    value={selectedRecord.last_name || ''}
                    onChange={handleChange}
                    disabled={!['new', 'edit'].includes(currentAction)}
                  />
                </Stack>
                <Stack sx={{ flex: 0.4 }} spacing={0.5} direction="row" alignItems="center">
                  <Typography sx={{ flex: 0.8, fontWeight: 700, fontSize: '14px' }}>Emp. ID</Typography>
                  <input
                    style={inputStyle}
                    sx={{ flex: 0.8 }}
                    name="emp_id"
                    placeholder="Emp. ID"
                    value={selectedRecord.emp_id || ''}
                    onChange={handleChange}
                    disabled={!['new', 'edit'].includes(currentAction)}
                  />
                </Stack>
              </Stack>
              <Stack spacing={2} direction="row" sx={{ mb: 0.25 }}>
                <Stack sx={{ flex: 0.4 }} spacing={0.5} direction="row" alignItems="center">
                  <Typography sx={{ flex: 0.8, fontWeight: 700, fontSize: '14px' }}>User Name</Typography>
                  <input
                    style={inputStyle}
                    sx={{ flex: 0.8 }}
                    name="username"
                    placeholder="User Name"
                    value={selectedRecord.username || ''}
                    onChange={handleChange}
                    disabled={!['new', 'edit'].includes(currentAction)}
                  />
                </Stack>
                <Stack sx={{ flex: 0.4 }} spacing={0.5} direction="row" alignItems="center">
                  <Typography sx={{ flex: 0.8, fontWeight: 700, fontSize: '14px' }}>Password</Typography>
                  <input
                    style={inputStyle}
                    sx={{ flex: 0.8 }}
                    type="password"
                    name="password"
                    placeholder="Password"
                    value={selectedRecord.password || ''}
                    onChange={handleChange}
                    disabled={!['new', 'edit'].includes(currentAction)}
                  />
                </Stack>
                <Stack sx={{ flex: 0.4 }} spacing={0.5} direction="row" alignItems="center">
                  <Typography sx={{ flex: 0.8, fontWeight: 700, fontSize: '14px' }}>Role</Typography>
                  <select
                    style={inputStyle}
                    className="form-control"
                    id="roleId"
                    name="roleId"
                    value={selectedRecord.roleId || ''}
                    onChange={handleChange}
                    disabled={!['new', 'edit'].includes(currentAction)}
                  >
                    <option value="">Select Role</option>
                    {roleDropdown.map((role) => (
                      <option key={role._id} value={role._id}>
                        {role.role}
                      </option>
                    ))}
                  </select>
                </Stack>
              </Stack>
              <Stack spacing={2} direction="row" sx={{ mb: 0.25 }}>
                <Stack sx={{ flex: 0.4 }} spacing={0.5} direction="row" alignItems="center">
                  <Typography sx={{ flex: 0.8, fontWeight: 700, fontSize: '14px' }}>Mobile No.</Typography>
                  <input
                    style={inputStyle}
                    sx={{ flex: 0.8 }}
                    name="mobile"
                    placeholder="Mobile"
                    value={selectedRecord.mobile || ''}
                    onChange={handleChange}
                    disabled={!['new', 'edit'].includes(currentAction)}
                  />
                </Stack>
                <Stack sx={{ flex: 0.4 }} spacing={0.5} direction="row" alignItems="center">
                  <Typography sx={{ flex: 0.8, fontWeight: 700, fontSize: '14px' }}>Email</Typography>
                  <input
                    style={inputStyle}
                    sx={{ flex: 0.8 }}
                    type="email"
                    name="email"
                    placeholder="Email"
                    value={selectedRecord.email || ''}
                    onChange={handleChange}
                    disabled={!['new', 'edit'].includes(currentAction)}
                  />
                </Stack>
                <Stack sx={{ flex: 0.4 }} spacing={0.5} direction="row" alignItems="center">
                  <Typography sx={{ flex: 0.8, fontWeight: 700, fontSize: '14px' }}>Designation</Typography>
                  <input
                    style={inputStyle}
                    sx={{ flex: 0.8 }}
                    name="designation"
                    placeholder="Designation"
                    value={selectedRecord.designation || ''}
                    onChange={handleChange}
                    disabled={!['new', 'edit'].includes(currentAction)}
                  />
                </Stack>
              </Stack>
            </Box>
          </FormProvider>
        </Container>
      </Paper>
    </>
  );
};
